module.exports = __webpack_public_path__ + "static/media/stationary.bf7e2042.svg";